// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterV1_root__B6faN","dark":"FooterV1_dark__QpxAp","light":"FooterV1_light__UDE3q","copy":"FooterV1_copy__GG_7T","links":"FooterV1_links__U2SFO"};